import React from 'react'
import {render} from 'react-dom'
import App from "./components/App"
import TopNav from "./components/TopNav"

import {
    Route,
    HashRouter,
    // BrowserRouter,
    Switch,
    // Redirect,
} from "react-router-dom";

// import 'antd/dist/antd.css';

import User from "./pages/user"
import Member from "./pages/member"
import Antd from "./pages/antd"
import Calculator from "./components/Calculator"

import Carousel from "./pages/carousel"
import Timer from "./pages/timer"
import QQRegister from "./pages/qq-register"
import "./index.css"


const el = (
    <HashRouter>
        <div style={{padding: 10}}>


            {/*<TopNav/>*/}

            <Switch>
                <Route exact path="/" component={App}></Route>
                <Route path="/user" component={User}></Route>
                <Route path="/calc" component={Calculator}></Route>
                <Route path="/member" component={Member}></Route>
                <Route path="/antd" component={Antd}></Route>
                <Route path="/carousel" component={Carousel}></Route>
                <Route path="/timer" component={Timer}></Route>
                <Route path="/timer" component={Timer}></Route>
                <Route path="/qqzc" component={QQRegister}></Route>
                <Route path="*">
                    <div>404 Not Found</div>
                </Route>
                {/*<Redirect to="/"/>*/}
            </Switch>
        </div>
    </HashRouter>
)

render(el, document.getElementById('root'))
